import styled from "styled-components";

export const StyledTitleSection = styled.div`
    color: ${({theme}) => theme.colors.dark};
    font-family: ${({theme}) => theme.fonts.helvetica};
    font-weight: 700;
    font-size: clamp(18px, 4vw, 24px);
    line-height: 24px;
    margin-bottom: 24px;

    span {
        color: ${({theme}) => theme.colors.lightBlue};
    }
`